import { withTranslate } from "@pathwright/ui/src/components/"
import Tab from "@pathwright/ui/src/components/tab/Tab"
import PropTypes from "prop-types"

const ResourceHeaderTabs = (
  { section, baseURL, discussionEnabled, t },
  { school, permissions }
) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginBottom: "1px"
    }}
  >
    {school.platform_version < 2.8 && (
      <Tab inverted active={section === "about"} to={`${baseURL}about/`}>
        {t("resource.header.tabs.about")}
      </Tab>
    )}
    <Tab inverted active={section === "path"} to={`${baseURL}path/`}>
      {permissions.can_access
        ? t("resource.header.tabs.path")
        : t("resource.header.tabs.preview")}
    </Tab>
    {discussionEnabled && (
      <Tab
        inverted
        active={section === "community"}
        to={`${baseURL}community/`}
      >
        {t("resource.header.tabs.community")}
      </Tab>
    )}
  </div>
)

ResourceHeaderTabs.displayName = "ResourceHeaderTabs"

ResourceHeaderTabs.contextTypes = {
  school: PropTypes.object,
  permissions: PropTypes.object
}

export default withTranslate(ResourceHeaderTabs)
